import React from 'react'
import ReactDOM from 'react-dom'

// Your top level component
import App from './App.jsx'

// Export your top level component as JSX (for static rendering)
export default App

if (typeof document !== 'undefined') {
    const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate || ReactDOM.render
    const render = Comp => {
        renderMethod(<Comp /> , document.getElementById('root'))
    }
    render(App)
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/index.js